import { Controller, useFormContext } from 'react-hook-form';
import { Accordion } from 'src/components/UI/Accordion';
import { TextArea } from 'src/components/UI/TextArea';
import { ConfirmAndPayFormData } from './index';

export const EmailAlertsAccordion = () => {
  const {
    control,
    formState: { errors }
  } = useFormContext<ConfirmAndPayFormData>();

  return (
    <Accordion title="Email Alerts" defaultExpanded={true}>
      <Controller
        name="emailAlerts"
        control={control}
        render={({ field }) => (
          <TextArea
            value={field.value || ''}
            onChange={(value) => field.onChange(value)}
            maxLength={1000}
            label="Enter email address(es):"
            placeholder="Enter 1 email address per line; max 5 email addresses. Leave this field empty if you do not want receive an email when this report is completed."
            error={!!errors.emailAlerts}
            helperText={errors.emailAlerts?.message}
          />
        )}
      />
    </Accordion>
  );
};
